<template>
  <div>
    <header id="mp-header">
      <div class="d-none d-md-flex top row">
        <slot name="navigation"></slot>
      </div>

      <div class="toolbar">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 text-center">
              <div class="group d-inline">
                <button class="btn action btn-transparent c-p" v-on:click="toggleContents">
                  <i class="fal fa-list-alt"></i>
                </button>
              </div>
              <div class="group d-inline">
                <button class="btn action btn-transparent c-p" v-on:click="toggleSearch">
                  <i class="fal fa-search"></i>
                </button>
              </div>

              <div class="group d-inline">
                <button class="btn action btn-transparent c-p" v-on:click="toggleDownload">
                  <i class="fal fa-download"></i>
                </button>
              </div>
              <div class="group d-inline">
                <button class="btn action btn-transparent c-p" v-on:click="toggleInfo">
                  <i class="fal fa-info-circle"></i>
                </button>
              </div>
              <div class="group d-inline">
                <button class="btn action btn-transparent c-p" @click="close">
                  <i class="fal fa-door-open"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loading" class="md-loader">
        <div class="md-loader-bar bg-c-p"></div>
      </div>
    </header>

    <div class="view_container">

      <div class="zoom_box d-none d-md-block">
        <button class="btn btn-light c-p" type="button" v-on:click="zoomIn">
          <i class="fal fa-plus"></i>
        </button>
        <button class="btn btn-light c-p" type="button" v-on:click="zoomOut">
          <i class="fal fa-minus"></i>
        </button>
      </div>

      <div id="md-zoom-container">
        <canvas id="the-canvas"></canvas>
      </div>

      <button v-if="showPrevButton" class="btn btn-transparent paging paging-left c-p" v-on:click="prevPage">
        <i class="fal fa-angle-left"></i>
      </button>
      <button v-if="showNextButton" class="btn btn-transparent paging paging-right c-p" v-on:click="nextPage">
        <i class="fal fa-angle-right"></i>
      </button>
    </div>

    <div class="mp-panel flex-column" v-bind:class="{ show: downloadShow }">
      <div class="titel c-p">
        {{ translations.download }}
        <button class="btn btn-light float-end" v-on:click="toggleDownload">
          <i class="float-end fal fa-times"></i>
        </button>
      </div>
      <div class="row p-3">
        <a class="btn btn-light col-12 mb-3 p-3 text-start" v-bind:class="{ 'disabled': downloadingPageDisable  }"
           v-bind:href="'/umbraco/mdpaper/page/Download?rootId=' + rootId + '&recordId=' + recordId + '&pageId=' + currentPage.id"
           v-on:click="startDownloadPage"> {{ translations.downloadPage }} <i class="fal fa-download float-end"
                                                                              v-bind:class="{ 'c-p': downloadingPage }"></i>
        </a> <a class="btn btn-light col-12 p-3 text-start" v-bind:class="{ 'disabled': downloadingRecordDisable  }"
                v-bind:href="'/umbraco/mdpaper/record/Download?rootId=' + rootId + '&recordId=' + recordId"
                v-on:click="startDownloadRecord"> {{ translations.downloadEdition }} <i
          class="fal fa-download float-end" v-bind:class="{ 'c-p': downloadingRecord  }"></i> </a>

      </div>
      <div v-if="downloadingPage || downloadingRecord" class="alert alert-info" role="alert">
        {{ translations.downloading }}
      </div>
    </div>

    <div class="mp-panel flex-column" v-bind:class="{ show: searchShow }">
      <div class="titel c-p">
        {{ translations.search }}
        <button class="btn btn-light float-end" v-on:click="toggleSearch">
          <i class="fal fa-times"></i>
        </button>
      </div>
      <md-paper-page-search
          v-on:page-selected="openPage($event.e, $event.pageNumber, $event.toggle)"></md-paper-page-search>
    </div>

    <div class="mp-panel flex-column" v-bind:class="{ show: contentsShow }">
      <div class="titel c-p">
        {{ translations.tableOfContents }}
        <button class="btn btn-light float-end" v-on:click="toggleContents">
          <i class="float-end fal fa-times"></i>
        </button>
      </div>
      <div class="row d-md-none mp-panel-scroll">
        <md-paper-page-item v-if="contentsShow" :current-page-id="currentPage.id"
                            :is-mobile="false" :pages="pages" @page-selected="openPage($event.e, $event.pageNumber, $event.toggle)"></md-paper-page-item>
      </div>
      <div class="row d-none d-md-flex mp-panel-scroll">
        <md-paper-page-item v-if="contentsShow" :current-page-id="currentPage.id"
                            :is-mobile="true" :pages="pages" @page-selected="openPage($event.e, $event.pageNumber, $event.toggle)"></md-paper-page-item>
      </div>
    </div>

    <div class="mp-panel flex-column" v-bind:class="{ show: infoShow }">
      <div class="titel c-p">
        {{ translations.info }}
        <button class="btn btn-light float-end" v-on:click="toggleInfo">
          <i class="float-end fal fa-times"></i>
        </button>
      </div>
      <div class="row p-3">
        <div class="col-12">
          <h4 class="text-uppercase">{{ translations.shortcuts }}</h4>
          <table class="table">
            <tr>
              <td class="align-middle">{{ translations.previousPage }}</td>
              <td class="align-middle">
                <img :alt="translations.previousPage" src="/img/multiPaper/taste_links.svg"/>
              </td>
            </tr>
            <tr>
              <td class="align-middle">{{ translations.nextPage }}</td>
              <td class="align-middle">
                <img :alt="translations.nextPage" src="/img/multiPaper/taste_rechts.svg"/>
              </td>
            </tr>
            <tr>
              <td class="align-middle">{{ translations.zoomIn }}</td>
              <td class="align-middle">
                <img :alt="translations.zoomIn" src="/img/multiPaper/taste_plus.svg"/>
              </td>
            </tr>
            <tr>
              <td class="align-middle">{{ translations.zoomOut }}</td>
              <td class="align-middle">
                <img :alt="translations.zoomOut" src="/img/multiPaper/taste_minus.svg"/>
              </td>
            </tr>
          </table>
        </div>
        <img alt="Multi Digital" class="md-logo" src="/img/multiPaper/MD_Logo_Claim.svg"/>

      </div>
      <div v-if="downloadingPage || downloadingRecord" class="alert alert-info" role="alert">
        {{ translations.downloading }}
      </div>
    </div>
  </div>
</template>

<script>
import {getParameterByName, showError} from "./helpers";
import {PdfViewer} from './pdf-viewer.js';
import axios from 'axios';
import _ from 'lodash';
import MdPaperPageItem from "./Components/PageItem.vue";
import MdPaperPageSearch from "./Components/PageSearch.vue";

let pdfViewer = {};

export default {
  name: 'MdPaperViewer',
  components: {
    MdPaperPageItem,
    MdPaperPageSearch
  },
  props: {
    rootId: Number
  },
  data() {
    return {
      pages: [],
      totalPages: 0,
      loading: false,
      downloadingPage: false,
      downloadingRecord: false,
      downloadingPageDisable: false,
      downloadingRecordDisable: false,
      contentsShow: false,
      infoShow: false,
      searchShow: false,
      downloadShow: false,
      showNextButton: false,
      pagingDisabled: false,
      showPrevButton: false,
      currentPage: {
        number: 1,
        id: ""
      }
    }
  },
  computed: {
    translations() {
      return multiPaper.translations;
    },
    recordId() {
      return this.$store.state.recordId;
    }
  },
  mounted: function () {
    let self = this;
    self.$store.state.recordId = getParameterByName("rid");
    let pageQuery = getParameterByName("p");
    self.currentPage.number = pageQuery !== null ? parseInt(pageQuery) : 1;

    pdfViewer = new PdfViewer();
    let header = document.getElementById("mp-header");
    let zoomContainer = document.getElementById("md-zoom-container");
    zoomContainer.style.top = (header.clientHeight) + "px";
    self.loadPages();

    // Prevent IOS zooming
    document.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });

    // Keybinding
    document.getElementsByTagName('body')[0].addEventListener('keydown', function (e) {
      if (document.activeElement.tagName !== 'INPUT') {
        if (e.keyCode === 37) {
          e.preventDefault();
          self.prevPage();
        } else if (e.keyCode === 39) {
          e.preventDefault();
          self.nextPage();
        } else if (e.keyCode === 107) {
          e.preventDefault();
          self.zoomIn();
        } else if (e.keyCode === 109) {
          e.preventDefault();
          self.zoomOut();
        }
      }
    });

  },
  methods: {
    close: function () {
      if (history.length > 1) {
        history.back();
      } else {
        window.close();
      }
    },
    zoomIn: function () {
      pdfViewer.getPage(1, 1.2);
    },
    zoomOut: function () {
      pdfViewer.getPage(1, 0.8);
    },
    nextPage: function (e) {
      let self = this;
      if (e) {
        e.preventDefault();
      }
      self.loadPage(self.currentPage.number + 1);
    },
    prevPage: function (e) {
      let self = this;
      if (e) {
        e.preventDefault();
      }
      self.loadPage(self.currentPage.number - 1);
    },
    openPage: function (e, pageNumber, toggle) {
      e.stopPropagation();
      let self = this;
      self.loadPage(pageNumber);
      if (toggle) {
        self.contentsShow = false;
        self.downloadShow = false;
        self.searchShow = false;
      }
    },
    loadPage: function (pageNumber) {
      let self = this;
      if (!self.pagingDisabled) {
        self.pagingDisabled = true;
        self.loading = true;
        self.currentPage = _.find(self.pages, function (o) {
          if (pageNumber > self.totalPages)
            return o.number === self.totalPages;
          if (pageNumber < 1)
            return o.number === 1;
          return o.number === pageNumber;
        });
        self.showPrevButton = self.currentPage.number !== 1;
        self.showNextButton = self.currentPage.number !== self.totalPages;
        pdfViewer.loadPdf("/umbraco/mdpaper/page/getPdf?recordId=" + self.$store.state.recordId + "&pageId=" + self.currentPage.id, function () {
          self.pagingDisabled = false;
          self.loading = false;
        });
      }
    },
    loadPages: function () {
      let self = this;
      self.loading = true;
      axios.get("/umbraco/mdpaper/page/GetAllFromRecord?recordId=" + self.$store.state.recordId).then(function (response) {
        self.pages = response.data.data;
        self.totalPages = response.data.total;
        self.loadPage(self.currentPage.number);
        self.loading = false;
      }).catch(showError);
    },
    toggleContents: function (e) {
      e.preventDefault();
      e.stopPropagation();
      let self = this;
      self.contentsShow = !self.contentsShow;
      self.downloadShow = false;
      self.searchShow = false;
      self.infoShow = false;
    },
    toggleSearch: function (e) {
      e.preventDefault();
      e.stopPropagation();
      let self = this;
      self.searchShow = !self.searchShow;
      self.downloadShow = false;
      self.contentsShow = false;
      self.infoShow = false;
    },
    toggleDownload: function (e) {
      e.preventDefault();
      e.stopPropagation();
      let self = this;
      self.downloadShow = !self.downloadShow;
      self.contentsShow = false;
      self.searchShow = false;
      self.infoShow = false;
    },
    toggleInfo: function (e) {
      e.preventDefault();
      e.stopPropagation();
      let self = this;
      self.infoShow = !self.infoShow;
      self.downloadShow = false;
      self.searchShow = false;
      self.contentsShow = false;
    },

    startDownloadPage: function () {
      let self = this;
      self.downloadingPage = true;
      self.downloadingPageDisable = true;
      window.setTimeout(function () {
        self.downloadingPage = false;
      }, 20000);
    },


    startDownloadRecord: function () {
      let self = this;
      self.downloadingRecord = true;
      self.downloadingRecordDisable = true;
      window.setTimeout(function () {
        self.downloadingRecord = false;
      }, 20000);
    }
  }
}
</script>